<template>
  <div></div>
</template>

<script>
import {Button, Cell, CellGroup, Col, Dialog, Field, Icon, Row, Tab, Tabbar, TabbarItem, Tabs, Toast} from 'vant';

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data() {
    return {}
  }
}

</script>

<style scoped>

</style>